import React from 'react'
// import './App.css'
import './css/general.css'
import './css/queries.css'
import './css/styles.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Navbar from './components/Navbar'
import HomeScreen from './screens/HomeScreen'
// import ReportIncidentScreen from './screens/ReportIncidentScreen'
import ContestScreen from './screens/ContestScreen'
import GoFundMeScreen from './screens/GoFundMeScreen'
import Footer from './components/Footer'
import MediaKitScreen from './screens/MediaKitScreen'
import SiteAdvertisingScreen from './screens/SiteAdvertisingScreen'
import SilentBiddingFormScreen from './screens/SilentBiddingFormScreen'
import DataInquiryScreen from './screens/DataInquiryScreen'
import FeedbackFormScreen from './screens/FeedbackFormScreen'
import IncidentSelector from './screens/Incident Selector'
import ReportIncidentForm from './screens/Report Incident'
import { Toaster } from 'react-hot-toast'
import ReactGA from "react-ga4"

const TRACKING_ID = "G-BV59JKWND1"
ReactGA.initialize(TRACKING_ID)

function App() {

  return (
    <Router>
      <Navbar />
      <Toaster
        toastOptions={{
          className: '',
          style: {
            border: '1px solid #713200',
            padding: '16px',
            color: '#000',
            fontSize: '16px',
          },
        }}
      />
      <Routes>
        {/* <Route path="/" element={<HomeScreen />} /> */}
        <Route path="/" element={<HomeScreen />} />
        {/* <Route path="/report" element={<ReportIncidentScreen />} /> */}
        <Route path="/report" element={<IncidentSelector />} />
        <Route path="/report/:id" element={<ReportIncidentForm />} />
        <Route path="/challenge" element={<ContestScreen />} />
        <Route path="/go-fund-me" element={<GoFundMeScreen />} />
        <Route path="/media-kit" element={<MediaKitScreen />} />
        <Route path="/site-advertising" element={<SiteAdvertisingScreen />} />
        <Route path="/data-inquiry" element={<DataInquiryScreen />} />
        <Route path="/feedback" element={<FeedbackFormScreen />} />
        <Route
          path="/silent-bidding-form"
          element={<SilentBiddingFormScreen />}
        />
      </Routes>
      <Footer />
    </Router>
  )
}

export default App
